import { Component } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';

@Component({
  selector: 'app-edit-design-name-modal',
  templateUrl: './edit-design-name-modal.component.html',
  styleUrls: ['./edit-design-name-modal.component.scss']
})
export class EditDesignNameModalComponent {
  designName: string;

  constructor(
    public modalRef: MdbModalRef<EditDesignNameModalComponent>,
  ) { }

  cancel() {
    this.designName = ''
    this.close();
  }

  close(): void {
    this.modalRef.close(this.designName)
  }
}
